import { HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const sectionHeaderCss = "sf37aca";
const SectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const tilesWrapperCss = "tz7x2n3";
const TilesWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tilesWrapperCss, props.className)} />;
});
export const Section = ({
  name,
  controls = null,
  children
}) => <>
    <SectionHeader>
      <HeadingText variant="eyebrow">{name}</HeadingText>
      {controls}
    </SectionHeader>
    <TilesWrapper>
      {children}
    </TilesWrapper>
  </>;

require("./section.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./section.js");